import { render } from "./FilterNewlyArrived.vue?vue&type=template&id=1aabf6df&ts=true"
import script from "./FilterNewlyArrived.vue?vue&type=script&lang=ts"
export * from "./FilterNewlyArrived.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__